import React, { useRef, useEffect } from "react"
import ReactDOM from "react-dom"
import mapboxgl from "mapbox-gl"
import "mapbox-gl/dist/mapbox-gl.css"
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css"
import markerIcon from "../../assets/icons/marker.png"
import * as turf from "@turf/turf"
// import newYorkPolygon from "../../constants/newYorkPolygon.json";
// import floridaPolygon from "../../constants/floridaPolygon.json";
// import miamiData from "../../constants/miamiData.json";
// Css import
import "./styles/heatmapSidebar.css"
// import hexagonGeoData from "../../constants/hexagonGeoData.json";
// import centersGeoData from "../../constants/centersGeoData.json";

mapboxgl.workerClass =
  // eslint-disable-next-line import/no-webpack-loader-syntax
  require("worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker").default

const MAPBOX_TOKEN =
  "pk.eyJ1IjoiYmFsamVldHJlYWN0IiwiYSI6ImNreW54ZmI2ZjNieGUybnFwNnd1aXRudTEifQ.a0Yo3o" +
  "2Cy1mID1653pidRA"

const HotspotHexagon = () => {
  const mapContainer = useRef(null)
  const map = useRef(null)

  useEffect(async () => {
    mapboxgl.accessToken = MAPBOX_TOKEN

    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      zoom: 6,
      // center: [-74.331279, 40.921665],
      center: [-82.728026, 29.125416],
      style: "mapbox://styles/mapbox/dark-v10"
    })

    let centersGeoData = {}
    map.current.on("load", () => {
      if (!map.current.hasImage("marker")) {
        let marker = new Image(27, 41)
        marker.onload = () => map.current.addImage("marker", marker)
        marker.src = markerIcon
      }

      // let newYorkBbox = [-80.912109, 38.927895, -67.464843, 45.681456];
      // let floridaBbox = [-89.362792, 24.780126, -78.728026, 31.125416];
      // let hexagonSide = 10; // hexagon side
      // let hexagonGeoData = turf.hexGrid(floridaBbox, hexagonSide);

      // hexagonGeoData.features = hexagonGeoData.features.filter((feature) => {
      //   return floridaPolygon.features.some((containerFeature) =>
      //     turf.booleanWithin(feature, containerFeature)
      //   );
      // });

      // let typeArr = ["available", "occupied", "blocked"];
      // turf.propEach(hexagonGeoData, (props, featureIndex) => {
      //   props.type = typeArr[Math.floor(Math.random() * 3)];
      //   props.hexIndex = featureIndex;
      // });

      // let hexagonCenters = [];
      // turf.featureEach(hexagonGeoData, (feature) => {
      //   hexagonCenters.push(turf.center(feature));
      // });

      // centersGeoData = turf.featureCollection(hexagonCenters);

      // // !map.current.getLayer("hexCenters") &&
      // //   map.current.addLayer({
      // //     id: "hexCenters",
      // //     type: "symbol",
      // //     source: {
      // //       type: "geojson",
      // //       data: centersGeoData,
      // //     },
      // //     layout: {
      // //       "icon-image": "marker",
      // //     },
      // //   });

      // !map.current.getLayer("hexCenters") &&
      //   map.current.addLayer({
      //     id: "hexCenters",
      //     type: "circle",
      //     source: {
      //       type: "geojson",
      //       data: centersGeoData,
      //     },
      //     paint: {
      //       "circle-radius": 3,
      //       "circle-color": "#fff",
      //     },
      //   });

      // // let points = [
      // //   {
      // //     lng: -79.74966254280515,
      // //     lat: 42.01573219017416,
      // //   },
      // //   {
      // //     lng: -79.74314808337483,
      // //     lat: 42.01674701863561,
      // //   },
      // //   {
      // //     lng: -79.75109560515338,
      // //     lat: 42.023616560040665,
      // //   },
      // // ];

      // // points = points.map((lngLat) =>
      // //   turf.point(lngLat, { type: "normal" })
      // // );

      // // let pointsGeoData = turf.featureCollection(points, "points");

      // // let nearestPoint = turf.nearestPoint(
      // //   centersGeoData.features[0],
      // //   pointsGeoData
      // // );

      // // let nearestPointIndex = nearestPoint.properties.featureIndex;

      // // pointsGeoData.features[nearestPointIndex].properties.type = "nearest";

      // // !map.current.getLayer("points") &&
      // //   map.current.addLayer({
      // //     id: "points",
      // //     type: "circle",
      // //     source: {
      // //       type: "geojson",
      // //       data: pointsGeoData,
      // //     },
      // //     paint: {
      // //       "circle-radius": 10,
      // //       "circle-color": {
      // //         property: "type", // geojson property based on which you want to change the color
      // //         type: "categorical",
      // //         stops: [
      // //           ["normal", "#fbb03b"],
      // //           ["nearest", "#3bb2d0"],
      // //         ],
      // //       },
      // //     },
      // //   });

      // let miamiPoints = miamiData.map((lngLat, index) =>
      //   turf.point(lngLat, { type: "normal", index })
      // );

      // let miamiPointsGeoData = turf.featureCollection(miamiPoints, "points");

      // let collected = turf.collect(
      //   hexagonGeoData,
      //   miamiPointsGeoData,
      //   "index",
      //   "pointsIndex"
      // );

      // let hexWithPoints = collected.features.filter(
      //   (feature) => feature.properties.pointsIndex.length
      // );

      // let hexWithPointsGeoJSON = turf.featureCollection(hexWithPoints);

      // turf.propEach(hexWithPointsGeoJSON, (props) => {
      //   let center = centersGeoData.features[props.hexIndex];
      //   let points = props.pointsIndex.map(
      //     (pointIndex) => miamiPoints[pointIndex]
      //   );
      //   let pointsGeo = turf.featureCollection(points);

      //   let nearestPoint = turf.nearestPoint(center, pointsGeo);

      //   let nearestPointIndex = nearestPoint.properties.index;
      //   miamiPointsGeoData.features[nearestPointIndex].properties.type =
      //     "nearest";
      //   props.nearestPoint = nearestPoint;
      //   // pointsGeoData.features[nearestPointIndex].properties.type = "nearest";
      // });

      // !map.current.getLayer("hexagonGrid") &&
      //   map.current.addLayer({
      //     id: "hexagonGrid",
      //     type: "fill",
      //     source: {
      //       type: "geojson",
      //       data: hexagonGeoData,
      //     },
      //     paint: {
      //       "fill-color": {
      //         property: "type",
      //         type: "categorical",
      //         stops: [
      //           ["available", "green"],
      //           ["occupied", "pink"],
      //           ["blocked", "red"],
      //         ],
      //       },
      //       "fill-outline-color": "white",
      //       "fill-opacity": 0.25,
      //     },
      //   });

      // !map.current.getLayer("miamiPoints") &&
      //   map.current.addLayer({
      //     id: "miamiPoints",
      //     type: "circle",
      //     source: {
      //       type: "geojson",
      //       data: miamiPointsGeoData,
      //     },
      //     paint: {
      //       "circle-radius": {
      //         property: "type",
      //         type: "categorical",
      //         stops: [
      //           ["normal", 5],
      //           ["nearest", 5],
      //         ],
      //       },
      //       "circle-color": {
      //         property: "type", // geojson property based on which you want to change the color
      //         type: "categorical",
      //         stops: [
      //           ["normal", "#3bb2d0"],
      //           ["nearest", "#fbb03b"],
      //         ],
      //       },
      //     },
      //   });
    })

    map.current.addControl(new mapboxgl.NavigationControl(), "bottom-right")

    map.current.on("click", "hexagonGrid", e => {
      let props = e.features[0].properties
      props.geometry = e.features[0].geometry
      props.center = centersGeoData.features[props.hexIndex]
      fetch(
        "https://api.mapbox.com/geocoding/v5/mapbox.places/" +
          props.center.geometry.coordinates[0] +
          "," +
          props.center.geometry.coordinates[1] +
          ".json?place_type=address&access_token=" +
          MAPBOX_TOKEN
      )
        .then(res => {
          return res.json()
        })
        .then(response => {
          let place = response.features.find(feature =>
            feature.id.includes("address")
          )
          if (place) {
            props.place = place
          }
          new mapboxgl.Popup()
            .setLngLat({
              lng: props.center.geometry.coordinates[0],
              lat: props.center.geometry.coordinates[1]
            })
            // .setHTML(Popup(props))
            .setHTML('<div id="test"></div>')
            .addTo(map.current)

          setTimeout(() => {
            ReactDOM.render(
              <Popup values={props} />,
              document.getElementById("test")
            )
          }, 20)
        })
    })
    // map.current.on("click", "hexagonGrid", (e) => {
    //   console.log(e.lngLat, "e");
    // });

    map.current.on("mouseenter", "hexagonGrid", () => {
      map.current.getCanvas().style.cursor = "pointer"
    })

    map.current.on("mouseleave", "hexagonGrid", () => {
      map.current.getCanvas().style.cursor = ""
    })
  }, [])

  return (
    <div className="hexagon-grid">
      <div className="sidebar-hexagon">
        <div className="colored-part">
          <h2>
            {" "}
            <a href="/heatmap">
              <i className="fa-solid fa-arrow-left-long"></i>
            </a>
            &nbsp; Hotspots
          </h2>
        </div>
        {/*HExagon Menus  */}
        <div className="hex-menus">
          <a href="#" className=" hex-menu full row-double">
            <h6>Total Hotspots</h6>
            <p>
              {" "}
              <b>100,000</b>
            </p>
            <div className="text-right">
              <i className="fa-solid fa-angle-right"></i>
            </div>
          </a>

          <a href="/supernest" className="hex-menu">
            <h6>Super Nest </h6>
            <p>100,000</p>
            <div className="text-right">
              <i className="fa-solid fa-angle-right"></i>
            </div>
          </a>
          <a href="/b2b" className="hex-menu">
            <h6>B2B </h6>
            <p>100,000</p>
            <div className="text-right">
              <i className="fa-solid fa-angle-right"></i>
            </div>
          </a>
          <a href="#" className="hex-menu ">
            <h6>Nester</h6>
            <p>100,000</p>
            <div className="text-right">
              <i className="fa-solid fa-angle-right"></i>
            </div>
          </a>
        </div>
      </div>
      <div ref={mapContainer} className="map-container"></div>
    </div>
  )
}

export default HotspotHexagon

const Popup = ({ values }) => {
  return (
    <>
      <p style={{ fontSize: 18, color: "black" }}>Hexagon Details: </p>
      <b>Type:</b>&nbsp; {values.type}
      <br />
      <b>No. of points:</b>&nbsp; {JSON.parse(values.pointsIndex).length}
      <br />
      <b>Center:</b>&nbsp;
      {values.center.geometry.coordinates.map((point, i) => (
        <React.Fragment key={i}>{point.toPrecision(6)}</React.Fragment>
      ))}
      <br />
      <b>Description:</b>&nbsp;
      {values.place ? values.place.place_name : "Not found"}
      <br />
      {values.type === "available" ? (
        <button
          className="gradient-box"
          style={{ margin: "auto", border: "none", color: "white" }}
          onClick={() => {
            console.log("Hello")
          }}>
          Register
        </button>
      ) : null}
    </>
  )
}
